import {
    Navigate,
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {EditPage} from "./pages/EditPage.tsx";
import {useVerifiedPermissions} from "../../hooks/useVerifiedPermissions.ts";


export const NotificationSubscriptionsLayout = () => {

    const {allowedActions} = useVerifiedPermissions();

    return (
        <Routes>
            <Route
                path='/'
                element={
                    allowedActions.includes('ListNotificationSubscriptions') ? (
                        <IndexPage/>
                    ) : (
                        <Navigate to='/'/>
                    )
                }
            />
            <Route
                path=':id'
                element={
                    allowedActions.includes('GetNotificationSubscription') ? (
                        <EditPage/>
                    ) : (
                        <Navigate to='/notification-subscriptions'/>
                    )
                }
            />
        </Routes>
    );
};
